// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-5bebc455]:export {\n  menuBg: #101820;\n  menuText: #8a97bb;\n  menuActiveText: #e48f93;\n  menuActiveBg: #934054;\n}\n\n/* Mixins */\n.edit-input[data-v-5bebc455] {\n  padding-right: 100px;\n}\n.cancel-btn[data-v-5bebc455] {\n  position: absolute;\n  right: 15px;\n  top: 10px;\n}", ""]);
// Exports
module.exports = exports;
